<ng-container *ngIf="initialized">
  <div class="sac-client-container" *ngIf="!clientStatusService.isMobile && stationIdentifierFromURL == null">

    <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

      <app-sac-header-container [sacClientContext]="sacClientContext"
        (structureSelected)="onStructureSelected($event)"></app-sac-header-container>

      <sc-content-spacer [vertical]="true"></sc-content-spacer>

      <sc-flex-fitting-content [vertical]="true" class="content-area">
        <sc-flex [fitHeight]="true" [stretchContent]="true" *ngIf="currentStructure != null">

          <sc-flex-fitting-content>
            <app-sac-stations [sacClientContext]="sacClientContext" [dashboardContext]="dashboardContext"
              [sacStructure]="currentStructure" (selectionChanged)="handleSelectionChange($event)">
            </app-sac-stations>
          </sc-flex-fitting-content>

          <sc-content-spacer></sc-content-spacer>

          <app-sac-transports 
            [selection]="selection"
            [sacClientContext]="sacClientContext" [dashboardContext]="dashboardContext"
            [refreshTrigger]="forceTransportListReload" *ngIf="sacClientContext.showTransports">
          </app-sac-transports>

        </sc-flex>
      </sc-flex-fitting-content>

    </sc-flex>
  </div>
  <app-sac-station-tablet *ngIf="!clientStatusService.isMobile && stationIdentifierFromURL != null" [station]="selection?.station"></app-sac-station-tablet>
  <app-mobile-sac *ngIf="clientStatusService.isMobile"></app-mobile-sac>
</ng-container>